import { PurchaseOrder } from 'types/purchaseOrder';

export type PayPurchaseOrderModalProps = {
  isOpen: boolean;
  onClose: () => void;
  purchaseOrder?: PurchaseOrder;
  onPurchaseOrderUpdated?: (purchaseOrder: PurchaseOrder) => void;
};

export const getPayPurchaseOrderDescription = (
  poNumber?: string,
  manufacturerName?: string,
) =>
  `Purchase Order ${poNumber || ''} payment to ${
    manufacturerName || ''
  }`.trim();

export const formatPayAmount = (value: number) =>
  value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
